// Detects whether an order's saved service lines changed in a way that affects stop dwell. The
// affected stops are resolved separately (by order_id) in useRecalcStopServiceTimes; this stays
// pure so it can be unit-tested.

// True when the saved service lines differ from the original in a way that changes a stop's
// service-time total: a line added, removed, or a changed service_time/quantity. Descriptive or
// billable-only edits don't count.
export const serviceLinesChanged = ({ original = [], modified = [], removed = [] } = {}) => {
    if ((removed || []).length > 0) return true;
    const origById = new Map((original || []).map((s) => [s.service_id, s]));
    return (modified || []).some((s) => {
        const prev = s.service_id ? origById.get(s.service_id) : null;
        return (
            !prev ||
            (prev.service_time ?? null) !== (s.service_time ?? null) ||
            (prev.quantity ?? null) !== (s.quantity ?? null)
        );
    });
};
